import { BATTERY_MODE_OPTIONS, BatteryModeId, DEFAULT_TRACKING_MODE_ID } from "../models/device-config";

/**
 * Returns the label for the battery mode.
 * 
 * @param batteryMode 
 * @returns 
 */
export const labelForBatteryMode = (batteryMode?: BatteryModeId): string => {
  if (!batteryMode) {
    batteryMode = DEFAULT_TRACKING_MODE_ID;
  }

  const option = BATTERY_MODE_OPTIONS.find((option) => option.id === batteryMode);
  return option ? option.label : '';
};

/**
 * Returns the description for the battery mode.
 * 
 * @param batteryMode 
 * @returns 
 */
export const descriptionForBatteryMode = (batteryMode?: BatteryModeId): string => {
  if (!batteryMode) {
    batteryMode = DEFAULT_TRACKING_MODE_ID;
  }

  const option = BATTERY_MODE_OPTIONS.find((option) => option.id === batteryMode);
  return option ? option.description : '';
};

/**
 * Returns the extra info description for the battery mode.
 * 
 * @param batteryMode 
 * @returns 
 */
export const extraInfoForBatteryMode = (batteryMode?: BatteryModeId): string | undefined => {
  if (!batteryMode) {
    batteryMode = DEFAULT_TRACKING_MODE_ID;
  }

  const option = BATTERY_MODE_OPTIONS.find((option) => option.id === batteryMode);
  return option?.extraInfo;
};


/**
 * Returns the duration description for the battery mode.
 * 
 * @param batteryMode 
 * @returns 
 */
export const durationDescriptionForBatteryMode = (batteryMode?: BatteryModeId): string => {
  if (!batteryMode) {
    batteryMode = DEFAULT_TRACKING_MODE_ID;
  }

  const option = BATTERY_MODE_OPTIONS.find((option) => option.id === batteryMode);
  return option ? option.durationDescription : '';
}